import { render, staticRenderFns } from "./testRouter1.vue?vue&type=template&id=9a6c6cc2&scoped=true"
import script from "./testRouter1.vue?vue&type=script&lang=js"
export * from "./testRouter1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6c6cc2",
  null
  
)

export default component.exports